import { render, staticRenderFns } from "./wxcollect.vue?vue&type=template&id=7dd3817e&scoped=true&"
import script from "./wxcollect.vue?vue&type=script&lang=js&"
export * from "./wxcollect.vue?vue&type=script&lang=js&"
import style0 from "./wxcollect.vue?vue&type=style&index=0&id=7dd3817e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd3817e",
  null
  
)

export default component.exports